import Graphic from "@arcgis/core/Graphic";

export interface ProjectsResponse {
    buildingPermitExpireDate: string | null;
    buildingPermitIssueDate: string | null;
    buildingPermitNumber: string | null;
    buildingPermitStage: string | null;
    comment: string | null;
    contractorOrgName: string | null;
    depositPayed: string | null;
    modificationDate: string | null;
    notificationId: number | null;
    oldWorkPermitId: number | null;
    projectId: number | null;
    stageId: number | null;
    stageName: string | null;
    statusId: number | null;
    statusNameForMadayn: ProjectStatus | null;
    workPermitContractorRegNumber: string | null;
    workPermitDatePayment: string | null;
    workPermitDescription: string | null;
    workPermitEstate: string | null;
    workPermitEstateId: number | null;
    workPermitExpireDate: string | null;
    workPermitId: number;
    workPermitIssueDate: string | null;
    workPermitNumber: string | null;
    workPermitStage: string | null;
    workPermitStageId: number | null;
    statusNameForContractor: ProjectStatus | null;
}

export interface TransformedProjectsData {
    id: number;
    statusAndModificationDate: string;
    contractorAndDescriptionOfWork: string;
    workPermitStatus: string;
    duration: string;
    stage: StageName;
    workPermitNumber: string | null;
    notificationId: number | null;
    status: ProjectStatus;
    issueDate: string;
    expireDate: string;
    modificationDate: string | null;
    descriptionOfWork: string | null;
    contractor: string | null;
    buildingPermitIssueDate: string | null;
    buildingPermitExpireDate: string | null;
    buildingPermitStage: string | null;
    buildingPermitNumber: string | null;
    workPermitEstateId: number | null;
    workPermitEstate: string | null;
    workPermitId: number;
    projectId: number | null;
    workPermitDatePayment: string | null;
    depositPayed: string | null;
    stageId: number | null;
    workPermitStage: string | null;
    contractorOrgName: string | null;
}

export const STATUS_PRIORITY_CONTRACTOR = {
    Rejected: 0,
    "Not initiated": 1,
    "Under review": 2,
    Approved: 3,
} as const;

export const STATUS_PRIORITY_DEPARTMENT_SPECIALIST = {
    "Need Approval": 0,
    Rejected: 1,
    "Not initiated": 2,
    Approved: 3,
} as const;

export interface ValidationIssue {
    layerName: string;
    reason: string;
}

export interface ValidationResult {
    isValid: boolean;
    issues: ValidationIssue[];
}

interface FileDataEntry {
    attributes: Record<string, any>;
    geometry: string;
}

interface FileData {
    graphics: FileDataEntry[];
    fileId: number;
    name: string;
    wkid: number;
    fields: any[];
}


interface Territory {
    buildingTerritoryGeometry: string;
    stageTerritoryGeometry: string;
    territoryId: number;
}

interface File {
    files: FileData[];
    stageId: number;
    stageName: string;
    territories: Territory[];
}

export type getProjectsResponse = File[];

export enum StageTypeId {
    Save = 1,
    Reject = 2,
    Approve = 3,
}

export enum ProjectStatus {
    NeedApproval = "Need approval",
    Rejected = "Rejected",
    NotInitiated = "Not initiated",
    Approved = "Approved",
    UnderReview = "Under review",
}

export interface StageGraphic extends Graphic {
    stage?: StageType;
}

export interface UploadedFile {
    id?: number;
    name: string;
    extension: string;
}

export interface UploadedFiles {
    design: UploadedFile[];
    asBuilt: UploadedFile[];
}

export type GeometryByStage = Record<StageType, Graphic | null>;

export interface SelectedFeature {
    layerName: string;
    attributes: Record<string, any>;
    graphic: Graphic;
    isArea: boolean;
    stage?: StageType;
}

export interface ConvertedGeometry {
    [fileName: string]: {
        graphics: StageGraphic[];
        fields?: any[];
        fileName?: string;
        fileId: number;
    };
}

export type ConvertedGeometryByStage = Record<StageType, ConvertedGeometry | null>

export type StageType = 'design' | 'asBuilt'
export type StageName = 'Design Stage' | 'As-Built';
export type TerritoryType = 'stage' | 'building'

export interface ProjectLog {
    id: number;
    userId: number;
    userName: string | null;
    eventTypeName: string;
    comment: string;
    changedDateTime: string;
}

export type GetProjectLogsResponse = ProjectLog[];